import { Component } from 'react'
import PropTypes from 'prop-types'
import Loader from './loader'

class ServerRenderLoader extends Component {
  static propTypes = {
    children: PropTypes.object,
  }

  state = {
    mounted: false,
  }

  componentDidMount() {
    this.setState({ mounted: true })
  }

  render() {
    return <Loader loading={!this.state.mounted}>{this.props.children}</Loader>
  }
}

export default ServerRenderLoader
